module.exports = __webpack_public_path__ + "static/media/shu23two.60884b80.avif";